export const wwtEngineNamespace = "wwt-engine";
export const wwtResearchAppNamespace = "wwt-research";
